






import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDocumentReferable } from "../../../domain/document";
import { PdfStyleDrawableMixin } from "../../system/mixins";
import PdfViewer from "../../system/viewers/PdfViewer.vue";

@Component({
  components: {
    PdfViewer,
  },
})
export default class ExistingDocumentViewer extends Mixins(PdfStyleDrawableMixin) {
  @Prop()
  document: IDocumentReferable;

  get isLoaded(): boolean {
    return !!this.document;
  }

  get isUnmanaged(): boolean {
    return this.document && this.document.isUnmanaged;
  }

  get shouldRenderDocumentPdfByPlugin(): boolean {
    return this.$configuration.behavior.document.viewer.pdfRendering.shouldRenderUnmanagedDocumentByPlugin && this.isUnmanaged;
  }
}
